// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-card {
  cursor: pointer;
}

.user-card-pending {
  top: -0.3rem;
  font-size: 0.75rem !important;
}

.user-card-img {
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  background-color: var(--gray-dark-color);
  width: 4rem;
  height: 4rem;
}

.user-card-img img {
  border: var(--gray-color) 1px solid;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  width: 4rem;
  height: 4rem;
  padding: 1rem;
  background-color: white;
}

.user-card-img.add-user img {
  background-color: var(--gray-dark-color);
  width: 4rem;
  height: auto;
  overflow: visible;
  border: transparent 0px solid;
}

.user-card-img span {
  font-size: 1.5rem;
  color: white;
}

.user-card-name {
  font-size: 0.75rem;
}

.user-card-description {
  color: var(--huckleberry-color);
  font-size: 0.75rem;
}

.btn-stop-sharing {
  width: 7.1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Board/UsersPanel/User/User.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAEA;EACE,YAAA;EACA,6BAAA;AACF;;AAEA;EACE,kBAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,wCAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,mCAAA;EACA,kBAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;AACF;;AAEA;EACE,wCAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,6BAAA;AACF;;AAEA;EACE,iBAAA;EACA,YAAA;AACF;;AACA;EACE,kBAAA;AAEF;;AAAA;EACE,+BAAA;EACA,kBAAA;AAGF;;AADA;EACE,aAAA;AAIF","sourcesContent":[".user-card {\n  cursor: pointer;\n}\n\n.user-card-pending {\n  top: -0.3rem;\n  font-size: 0.75rem !important;\n}\n\n.user-card-img {\n  border-radius: 50%;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n  background-color: var(--gray-dark-color);\n  width: 4rem;\n  height: 4rem;\n}\n\n.user-card-img img {\n  border: var(--gray-color) 1px solid;\n  border-radius: 50%;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n  width: 4rem;\n  height: 4rem;\n  padding: 1rem;\n  background-color: white;\n}\n\n.user-card-img.add-user img {\n  background-color: var(--gray-dark-color);\n  width: 4rem;\n  height: auto;\n  overflow: visible;\n  border: transparent 0px solid;\n}\n\n.user-card-img span {\n  font-size: 1.5rem;\n  color: white;\n}\n.user-card-name {\n  font-size: 0.75rem;\n}\n.user-card-description {\n  color: var(--huckleberry-color);\n  font-size: 0.75rem;\n}\n.btn-stop-sharing {\n  width: 7.1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
